'use client'

import React from 'react'

const instagramPosts = [
  {
    id: 1,
    username: '@cliente_airlovers_1',
    image: '/images/gallery/buff_04.jpeg',
    caption: '¡La mejor experiencia de mi vida! 🪂'
  },
  {
    id: 2,
    username: '@cliente_airlovers_2',
    image: '/images/gallery/buff_05.jpeg',
    caption: 'Vista increíble desde las alturas 🏔️'
  },
  {
    id: 3,
    username: '@cliente_airlovers_3',
    image: '/images/gallery/buff_06.jpg',
    caption: 'Gracias @airloverscolombia por este momento único'
  },
  {
    id: 4,
    username: '@cliente_airlovers_4',
    image: '/images/gallery/buff_07.jpg',
    caption: '100% recomendado. ¡Volveré pronto! 🎁'
  }
]

export default function FamiliaAirlovers() {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-900 to-black relative z-10">
      <div className="container mx-auto px-4 relative z-20">
        {/* Título */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-bisteron text-white mb-4">
            Únete a la <span className="text-blue-400">Familia Airlovers</span> 🪂
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Miles de personas ya vivieron la experiencia. Ahora te toca a ti.
          </p>
        </div>

        {/* Cómo Funciona */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 max-w-5xl mx-auto">
          <div className="text-center p-6 bg-white/5 rounded-xl border border-white/10">
            <div className="w-16 h-16 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">🪂</span>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">1. Vuela con Nosotros</h3>
            <p className="text-gray-400 text-sm">
              Elige tu experiencia favorita. Recomendamos PRO o PRO MAX para obtener tu buff de regalo.
            </p>
          </div>

          <div className="text-center p-6 bg-white/5 rounded-xl border border-white/10">
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">📸</span>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">2. Recibe tu Buff</h3>
            <p className="text-gray-400 text-sm">
              Te entregamos tu buff personalizado con el logo de Airlovers. ¡Úsalo durante el vuelo!
            </p>
          </div>

          <div className="text-center p-6 bg-white/5 rounded-xl border border-white/10">
            <div className="w-16 h-16 bg-pink-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">📱</span>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">3. Etiqueta en Redes</h3>
            <p className="text-gray-400 text-sm">
              Comparte tu experiencia y etiqueta @airloverscolombia. ¡Gana descuentos en próximos vuelos!
            </p>
          </div>
        </div>

        {/* Grid de Fotos de Instagram */}
        <div className="mb-12">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-white mb-2">
              #FamiliaAirlovers en Instagram
            </h3>
            <p className="text-gray-400">
              Sigue a <span className="text-blue-400 font-semibold">@airloverscolombia</span> y etiqueta tus fotos
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {instagramPosts.map((post) => (
              <div
                key={post.id}
                className="relative group aspect-square overflow-hidden rounded-xl bg-gray-800 cursor-pointer"
              >
                <img
                  src={post.image}
                  alt={post.caption}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                {/* Overlay con info */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <p className="text-white text-xs font-medium truncate">{post.username}</p>
                    <p className="text-gray-300 text-xs truncate">{post.caption}</p>
                  </div>
                </div>
                {/* Icono de Instagram */}
                <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.285.068 2.208.068 4.85s-.012 3.565-.068 4.85c-.145 3.225-1.664 4.771-4.919 4.919-1.285.058-2.208.058-4.85.058s-3.565-.012-4.85-.058c-3.252-.148-4.771-1.691-4.919-4.919-.058-1.285-.068-2.208-.068-4.85s.012-3.565.068-4.85c.145-3.225 1.664-4.771 4.919-4.919 1.285-.058 2.208-.058 4.85-.058zm0-2.163C6.846 0 5.954 0 5.052 0c-1.605 0-3.069.447-4.285 1.197C.435 1.654.0 3.118.0 4.732c0 1.615.435 3.078 1.052 3.535C1.654 8.87 2.0 10.334 2.0 11.948c0 1.615-.435 3.078-1.052 3.681C.435 16.092 0 17.556 0 19.17c0 1.615.435 3.078 1.052 3.535C1.654 23.21 3.118 23.645 4.732 23.645c1.615 0 3.078-.435 3.681-1.052.603-.617 2.067-1.052 3.681-1.052 1.615 0 3.078.435 3.681 1.052.603.617 2.067 1.052 3.681 1.052 1.615 0 3.078-.435 3.535-1.052.617-.603 2.08-1.052 3.695-1.052 1.614 0 3.078.435 3.535 1.052.457.617 1.92 1.052 3.535 1.052 1.614 0 3.078-.435 3.681-1.052.603-.617 2.067-1.052 3.681-1.052z"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Beneficios por Etiquetar */}
        <div className="bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-2xl p-8 border border-white/10 max-w-4xl mx-auto">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold text-white mb-2">
              🎁 Beneficios por Etiquetarnos
            </h3>
            <p className="text-gray-400">
              Cuando compartes tu experiencia y nos etiquetas, ganas:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-3xl mb-2">💰</div>
              <h4 className="text-white font-semibold mb-1">5% de Descuento</h4>
              <p className="text-gray-400 text-sm">En tu próximo vuelo o en el de un amigo</p>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">🎯</div>
              <h4 className="text-white font-semibold mb-1">Contenido Destacado</h4>
              <p className="text-gray-400 text-sm">Te reposteamos en nuestras stories</p>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">🏆</div>
              <h4 className="text-white font-semibold mb-1">Acceso VIP</h4>
              <p className="text-gray-400 text-sm">Invitaciones a eventos especiales</p>
            </div>
          </div>
        </div>

        {/* CTA Final */}
        <div className="text-center mt-12">
          <a
            href="https://wa.me/573028309637?text=¡Hola!%20Quiero%20ser%20parte%20de%20la%20Familia%20Airlovers%20🪂"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-blue-500/25"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981z"/>
            </svg>
            ¡Quiero Ser Parte de la Familia!
          </a>
        </div>
      </div>
    </section>
  )
}